import { render, staticRenderFns } from "./experience-list.vue?vue&type=template&id=2cdd2a18&scoped=true&lang=html&"
import script from "./experience-list.vue?vue&type=script&lang=js&"
export * from "./experience-list.vue?vue&type=script&lang=js&"
import style0 from "./experience-list.vue?vue&type=style&index=0&id=2cdd2a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd2a18",
  null
  
)

export default component.exports